// Determine whether to inject tcb_anchor script
const tcbLink = document.querySelector('main .tcb, main .tcb-link');
const isSmallBreakpoint = window.matchMedia('(max-width: 1024px)').matches;
const isRC = document.body.classList.contains('is-rc');

if ( typeof window.load_tcb === 'function' && (isRC || isSmallBreakpoint || tcbLink)) {
	// Load trevor chat button provided by the plugin
	window.load_tcb();
}
